<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="asegurados"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Base Futuro</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <v-file-input
              v-if="$store.state.usuario.nombre == 'administrador'"
              label="Click aquí"
              hint="Archivo Excel Base de datos"
              persistent-hint
              @change="cargarExcel()"
            >
            </v-file-input>

            <v-file-input
              v-if="$store.state.usuario.nombre == 'administrador'"
              label="Click aquí"
              hint="Archivo Excel Desactivar"
              persistent-hint
              @change="cargarExcelDesactivar()"
              class="mx-3"
            >
            </v-file-input>

            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
            ></v-text-field>
            <v-btn
              v-if="esAdministrador()"
              class="ml-3"
              rounded
              color="primary"
              @click="dialogMessageTruncate = true"
              >Borrar Registros</v-btn
            >
            <v-dialog v-model="dialog" max-width="700px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="poliza"
                          label="POLIZA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8">
                        <v-text-field
                          v-model="asegurado"
                          label="ASEGURADO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="fechaEmision"
                          label="FECHA EMISION"
                          hint="Ejemplo: YYYY/MM/DD"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="inicioVigencia"
                          label="INICIO VIGENCIA"
                          hint="Ejemplo: YYYY/MM/DD"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="finVigencia"
                          label="FIN VIGENCIA"
                          hint="Ejemplo: YYYY/MM/DD"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="tipo"
                          label="TIPO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="marca"
                          label="MARCA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="modelo"
                          label="MODELO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="placa"
                          label="PLACA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          type="number"
                          v-model="año"
                          label="AÑO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="vin" label="VIN"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="motor"
                          label="MOTOR"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="uso" label="USO"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="color"
                          label="COLOR"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <div
                          class="red--text"
                          v-for="v in validaMensaje"
                          :key="v"
                          v-text="v"
                        ></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="close">CERRAR</v-btn>
                  <v-btn
                    v-if="esAdministrador()"
                    color="success"
                    @click="guardar"
                    >GUARDAR</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="addModal" max-width="290px">
              <v-card>
                <v-card-title class="headline" v-if="addAccion == 1"
                  >¿Activar Item?</v-card-title
                >
                <v-card-title class="headline" v-if="addAccion == 2"
                  >Desactivar Item?</v-card-title
                >
                <v-card-text>
                  Estas a punto de
                  <span v-if="addAccion == 1">activar</span>
                  <span v-if="addAccion == 2">desactivar</span>
                  el cliente {{ addAsegurado }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="ActivarDesactivarCerrar">
                    Cancelar
                  </v-btn>
                  <v-btn v-if="addAccion == 1" color="success" @click="activar">
                    Activar
                  </v-btn>
                  <v-btn
                    v-if="addAccion == 2"
                    color="warning"
                    @click="desactivar"
                  >
                    Desactivar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogMessageTruncate" max-width="500">
              <v-card>
                <v-card-text class="headline font-weight-bold pt-2"
                  >Esta a punto de eliminar la base de datos</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey"
                    dark
                    @click="dialogMessageTruncate = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="orange" dark @click="truncarBase()"
                    >Continuar</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
          <template v-if="item.condicion && esAdministrador()">
            <v-icon small @click="ActivarDesactivar(2, item)"> block </v-icon>
          </template>
          <template v-else-if="esAdministrador()">
            <v-icon small @click="ActivarDesactivar(1, item)"> check </v-icon>
          </template>
        </template>
        <template v-slot:[`item.condicion`]="{ item }">
          <v-chip :color="getColorCondicion(item.condicion)" dark>
            <div v-if="item.condicion"><span>Activo</span></div>
            <div v-else><span>Inactivo</span></div>
          </v-chip>
        </template>
      </v-data-table>
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-dialog v-model="dialogProgress" max-width="250">
        <v-card>
          <v-row no-gutters justify="center">
            <v-col cols="8">
              <progress-bar class="mx-1" :options="options" :value="contador" />
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import XLSX from "xlsx";
export default {
  data() {
    return {
      dialog: false,
      asegurados: [],
      headers: [
        { text: "Opciones", value: "action", sortable: true },
        { text: "Asegurado", value: "asegurado", sortable: true },
        { text: "Fecha Emision", value: "fechaEmision", sortable: true },
        { text: "Inicio Vigencia", value: "inicioVigencia", sortable: true },
        { text: "Fin Vigencia", value: "finVigencia", sortable: true },
        { text: "Placa", value: "placa", sortable: true },
        { text: "Marca", value: "marca", sortable: true },
        { text: "Modelo", value: "modelo", sortable: true },
        { text: "Color", value: "color" },
        { text: "Estado", align: "left", value: "condicion", sortable: true },
      ],
      search: "",
      editedIndex: -1,
      id: "",
      indice: "",
      correlativo: 0,
      poliza: "",
      asegurado: "",
      fechaEmision: "",
      inicioVigencia: "",
      finVigencia: "",
      tipo: "",
      marca: "",
      modelo: "",
      placa: "",
      año: 0,
      vin: "",
      motor: "",
      uso: "",
      color: "",
      valida: 0,
      validaMensaje: [],
      addModal: 0,
      addAccion: 0,
      addAsegurado: "",
      addId: "",
      indicesheetdb: "",
      correlativosheetdb: "",
      polizasheetdb: "",
      aseguradosheetdb: "",
      fechaEmisionsheetdb: "",
      inicioVigenciasheetdb: "",
      finVigenciasheetdb: "",
      tiposheetdb: "",
      marcasheetdb: "",
      modelosheetdb: "",
      placasheetdb: "",
      añosheetdb: "",
      vinsheetdb: "",
      motorsheetdb: "",
      usosheetdb: "",
      colorsheetdb: "",
      overlay: false,
      page: 1,
      infiniteId: +new Date(),
      file: "",
      contador: 0,
      dialogMessageTruncate: false,
      dialogProgress: false,
      //variables de excel
      polizaExcel: "",
      aseguradoExcel: "",
      fechaEmisionExcel: "",
      inicioVigenciaExcel: "",
      finVigenciaExcel: "",
      tipoExcel: "",
      marcaExcel: "",
      modeloExcel: "",
      placaExcel: "",
      añoExcel: "",
      vinExcel: "",
      motorExcel: "",
      usoExcel: "",
      colorExcel: "",
      cantidadRegistros: 0,
      chatId: -1001607334169,
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
      dataTypeParticular: 0,
      dataTypeAlquilerAuto: 0,
      dataTypeAlquilerTaxi: 0,
      dataTypeCamiones: 0,
      dataTypeComercial: 0,
      dataTypeMotos: 0,
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "cylinder",
        },
      },
    };
  },
  components: {
    InfiniteLoading,
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo" : "Actualizar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    cargarExcel() {
      this.dialogProgress = true;
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);

          this.cantidadRegistros = data.length;
          this.agregarCliente(data);
        };

        reader.readAsBinaryString(this.file);
      }
    },
    async agregarCliente(data) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      var i;
      var j = 0;
      me.contador = 0;
      for (i = 0; i < data.length; i++) {
        j = j + 1; //contador para el progress
        me.contador = parseInt(((j / data.length) * 100).toFixed(0));
        me.polizaExcel = data[i]["poliza"];
        me.aseguradoExcel = data[i]["asegurado"];
        me.fechaEmisionExcel = data[i]["fechaEmision"];
        me.inicioVigenciaExcel = data[i]["inicioVigencia"];
        me.finVigenciaExcel = data[i]["finVigencia"];
        me.tipoExcel = data[i]["tipo"];
        me.marcaExcel = data[i]["marca"];
        me.modeloExcel = data[i]["modelo"];
        me.placaExcel = data[i]["placa"];
        me.añoExcel = data[i]["año"];
        me.vinExcel = data[i]["vin"];
        me.motorExcel = data[i]["motor"];
        me.usoExcel = data[i]["uso"];
        me.colorExcel = data[i]["color"];

        switch(data[i]["uso"]){
          case "Particular":
            me.dataTypeParticular = me.dataTypeParticular + 1;
            break;
          case "CAMIONES":
            me.dataTypeCamiones = me.dataTypeCamiones + 1;
            break;
          case "Alquiler(Autos)":
            me.dataTypeAlquilerAuto = me.dataTypeAlquilerAuto + 1;
            break;
          case "Alquiler(Taxis)":
            me.dataTypeAlquilerTaxi = me.dataTypeAlquilerTaxi + 1;
            break;
          case "Comercial":
            me.dataTypeComercial = me.dataTypeComercial + 1;
            break;
          case "MOTOS":
            me.dataTypeMotos = me.dataTypeMotos + 1;
            break;
        }

        await axios
          .post(
            "api/Asegurados/Crear",
            {
              poliza: me.polizaExcel,
              asegurado: me.aseguradoExcel,
              fechaEmision: me.fechaEmisionExcel,
              inicioVigencia: me.inicioVigenciaExcel,
              finVigencia: me.finVigenciaExcel,
              tipo: me.tipoExcel,
              marca: me.marcaExcel,
              modelo: me.modeloExcel,
              placa: me.placaExcel,
              año: me.añoExcel,
              vin: me.vinExcel,
              motor: me.motorExcel,
              uso: me.usoExcel,
              color: me.colorExcel,
            },
            configuracion
          )
          .then(function (response) {
            me.limpiarDatosExcel();
            if (j == data.length) {
              me.dialogProgress = false;
              me.listar();
              me.notificacionTelegram();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    truncarBase() {
      let me = this;
      me.overlay = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Asegurados/TrucarBaseAssa", configuracion)
        .then(function (response) {
          me.dialogMessageTruncate = false;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiarDatosExcel() {
      this.polizaExcel = "";
      this.aseguradoExcel = "";
      this.fechaEmisionExcel = "";
      this.inicioVigenciaExcel = "";
      this.finVigenciaExcel = "";
      this.tipoExcel = "";
      this.marcaExcel = "";
      this.modeloExcel = "";
      this.placaExcel = "";
      this.añoExcel = "";
      this.vinExcel = "";
      this.motorExcel = "";
      this.usoExcel = "";
      this.colorExcel = "";
    },
    esAdministrador() {
      if (this.$store.state.usuario.nombre == "administrador") {
        return true;
      } else {
        return false;
      }
    },
    getExcel() {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          console.log("DATA", data);
        };

        reader.readAsBinaryString(this.file);
      }
    },
    listarPagina($state) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      console.log(me.page);
      axios
        .get(
          "api/Asegurados/ListarPagina?PageNumber=" + me.page + "&pageSize=10",
          configuracion
        )
        .then(function (response) {
          if (response.data.length) {
            console.log(response.data);
            me.asegurados.push(...response.data);
            me.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(function (error) {
          console.log("ERROR", error);
        });
    },
    listar() {
      let me = this;
      me.overlay = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Asegurados/Listar", configuracion)
        .then(function (response) {
          me.asegurados = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getColorCondicion(condicion) {
      if (condicion == true) {
        return "green";
      } else {
        return "red";
      }
    },
    editItem(item) {
      this.id = item.idBase;
      this.indice = item.indice;
      this.correlativo = item.correlativo;
      this.poliza = item.poliza;
      this.asegurado = item.asegurado;
      this.fechaEmision = item.fechaEmision;
      this.inicioVigencia = item.inicioVigencia;
      this.finVigencia = item.finVigencia;
      this.tipo = item.tipo;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.placa = item.placa;
      this.año = item.año;
      this.vin = item.vin;
      this.motor = item.motor;
      this.uso = item.uso;
      this.color = item.color;
      this.editedIndex = 1;
      this.dialog = true;
    },
    ActivarDesactivar(accion, item) {
      this.addModal = 1;
      this.addAsegurado = item.asegurado;
      this.addId = item.idBase;
      if (accion == 1) {
        this.addAccion = 1;
      } else if (accion == 2) {
        this.addAccion = 2;
      } else {
        this.addModal = 0;
      }
    },
    ActivarDesactivarCerrar() {
      this.addModal = 0;
    },
    close() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.indice = "";
      this.correlativo = "";
      this.poliza = "";
      this.asegurado = "";
      this.fechaEmision = "";
      this.inicioVigencia = "";
      this.finVigencia = "";
      this.tipo = "";
      this.marca = "";
      this.modelo = "";
      this.placa = "";
      this.año = "";
      this.vin = "";
      this.motor = "";
      this.uso = "";
      this.color = "";
      this.editedIndex = -1;
    },
    guardar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put(
            "api/Asegurados/Actualizar",
            {
              idBase: me.id,
              indice: me.indice,
              correlativo: me.correlativo,
              poliza: me.poliza,
              asegurado: me.asegurado,
              fechaEmision: me.fechaEmision,
              inicioVigencia: me.inicioVigencia,
              finVigencia: me.finVigencia,
              tipo: me.tipo,
              marca: me.marca,
              modelo: me.modelo,
              placa: me.placa,
              año: me.año,
              vin: me.vin,
              motor: me.motor,
              uso: me.uso,
              color: me.color,
            },
            configuracion
          )
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post(
            "api/Asegurados/Crear",
            {
              indice: me.indice,
              correlativo: me.correlativo,
              poliza: me.poliza,
              asegurado: me.asegurado,
              fechaEmision: me.fechaEmision,
              inicioVigencia: me.inicioVigencia,
              finVigencia: me.finVigencia,
              tipo: me.tipo,
              marca: me.marca,
              modelo: me.modelo,
              placa: me.placa,
              año: me.año,
              vin: me.vin,
              motor: me.motor,
              uso: me.uso,
              color: me.color,
            },
            configuracion
          )
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    activar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Asegurados/Activar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Asegurados/Desactivar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //Metodos para descativar al cliente desde un archivo excel
    cargarExcelDesactivar() {
      this.dialogProgress = true;
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          //console.log("DATA", data);
          this.desactivarCliente(data);
        };

        reader.readAsBinaryString(this.file);
      }
    },
    desactivarCliente(data) {
      let me = this;
      var i;
      for (i = 0; i < data.length; i++) {
        me.enviarDesactivar(data[i]["placa"]);
      }
    },
    async enviarDesactivar(placa) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      await axios
        .put(
          "api/Asegurados/DesactivarV2/" + placa,
          {},
          configuracion
        )
        .then(function (response) {
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async notificacionTelegram() {
      var today = new Date();
      var fechaActual =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      var cuenta = "FUTURO ASISTENCIA";
      var cantRegistros = this.cantidadRegistros;
      var mensaje =
        "Se notifica sobre la siguiente actualización de la base de datos de la cuenta: " +
        cuenta +
        "%0A" +
        "Fecha de la actualización: " +
        fechaActual +
        "%0A" +
        "Cantidad de registros que fueron agregados: " +
        cantRegistros +
        "%0A" +
        "Con los detalles: " +
        "%0A" +
        "Particulares: " + this.dataTypeParticular + 
        "%0A" +
        "Alquiler(Taxis): " + this.dataTypeAlquilerTaxi +
        "%0A" +
        "Alquiler(Auto): " + this.dataTypeAlquilerAuto +
        "%0A" +
        "Comercial: " + this.dataTypeComercial +
        "%0A" +
        "Camiones: " + this.dataTypeCamiones +
        "%0A" +
        "Motos: " + this.dataTypeMotos;

      await axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatId +
            "&text=" +
            mensaje
        )
        .then((response) => {
          console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
  },
};
</script>
